var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 20.496,
    viewBox: "0 0 20.5 20.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook\\u30ED\\u30B0\\u30A4\\u30F3_\\u9752_",
    "data-name": "Facebook\\u30ED\\u30B0\\u30A4\\u30F3\\uFF08\\u9752\\uFF09",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f_logo_RGB-White_1024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M20.5,10.31A10.25,10.25,0,1,0,8.648,20.5v-7.2h-2.6V10.31h2.6V8.039c0-2.584,1.53-4.011,3.872-4.011a15.673,15.673,0,0,1,2.294.2V6.766H13.522a1.486,1.486,0,0,0-1.67,1.61V10.31h2.843l-.454,2.98H11.852v7.2A10.3,10.3,0,0,0,20.5,10.31",
    fill: "#1878f3",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo_facebook.3dc81b64fb4b552257a7ee5b45d35147.svg";
export { ForwardRef as ReactComponent };